module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-up-2a53274e4d86bd9a9e0440680e5ce4f2.svg";